import axios from "axios"

const server = axios.create({
  baseURL: "/",
  responseType: "json",
  headers: {
    "X-CSRF-Token": document.getElementsByName("csrf-token")[0]["content"],
  },
})

const request = async ({
  path,
  method,
  data,
  asFormData = false,
}: {
  path: string
  method: string
  data: any
  asFormData: boolean
}) => {
  const headers = asFormData ? { "Content-Type": "multipart/form-data" } : {}

  try {
    const response = await server({
      method,
      url: path,
      data,
      headers,
    })
    return response.data
  } catch (error: any) {
    throw error.response.data
  }
}

export default request
